<section class="dialog-section">
  <div class="dialog-container">
    <div class="dialog-card">
      <!-- Header -->
      <div class="dialog-header">
        <h1 class="dialog-title">Captcha</h1>
        <p class="dialog-subtitle">{{ "page.registration.captcha.description" | translate }}</p>
      </div>

      <!-- Loading -->
      <mat-spinner *ngIf="isLoading"></mat-spinner>

      <!-- Content -->
      <div *ngIf="!isLoading" class="dialog-content">
        <!-- Image + refresh -->
        <div class="image-container">
          <img [src]="captchaImage" alt="Generated captcha image" />

          <button
            mat-icon-button
            aria-label="Icon button with a refresh icon"
            class="change-icon-bg-color"
            color="primary"
            (click)="onNewCaptcha()"
          >
            <mat-icon>refresh</mat-icon>
          </button>
        </div>

        <!-- Answer -->
        <div class="form-group">
          <label for="captcha-dialog-userAnswer" class="form-label">{{ "form.answer" | translate }}</label>

          <div class="answer-row">
            <input
              type="text"
              [(ngModel)]="userAnswer"
              class="form-input"
              id="captcha-dialog-userAnswer"
              (keyup.enter)="onVerifyCaptcha()"
            />
            <mat-progress-spinner diameter="25" mode="determinate" color="warn" [value]="progressValue"></mat-progress-spinner>
          </div>
        </div>
      </div>

      <!-- Actions -->
      <div class="dialog-actions">
        <button class="secondary-button" (click)="close()">
          {{ "button.cancel" | translate }}
        </button>

        <button class="primary-button" (click)="onVerifyCaptcha()" [disabled]="!userAnswer" id="captcha-dialog-validate">
          {{ "button.validate" | translate }}
        </button>
      </div>
    </div>
  </div>
</section>
